module.exports = __webpack_public_path__ + "static/media/plan-ex3.4e6d4f44.png";